// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"jo_TUZU","gradient":"L0w95XS","skeleton-loader--pill":"zsIEh6Q"};